import React, { Component } from 'react';
import { getMatchBounds } from 'react-bootstrap-typeahead/lib/utils';
import propTypes from 'prop-types';

/**
 * text highlighter that supports className and title
 * based on react-bootstrap-typeahead's default highlighter
 */
export default class Highlighter extends Component {
  static propTypes = {
    className: propTypes.string,
    search: propTypes.string,
    text: propTypes.string
  };

  static defaultProps = {
    className: '',
    search: '',
    text: ''
  };

  constructor(props) {
    super(props);

    this.count = 0;
  }

  /**
   * render text with search prop highlighted
   * @returns {Array} array of react components
   */
  renderHighlights() {
    const children = [];
    let { text: remaining } = this.props;

    while (remaining) {
      const bounds = getMatchBounds(remaining, this.props.search);

      if (!bounds) {
        this.count++;
        children.push(<span key={this.count}>{remaining}</span>);
        return children;
      }

      // Capture the string that leads up to a match...
      const nonMatch = remaining.slice(0, bounds.start);
      if (nonMatch) {
        this.count++;
        children.push(<span key={this.count}>{nonMatch}</span>);
      }

      // Now, capture the matching string...
      const match = remaining.slice(bounds.start, bounds.end);
      if (match) {
        this.count++;
        children.push(
          <mark className="rbt-highlight-text" key={this.count}>
            {match}
          </mark>
        );
      }

      // And if there's anything left over, continue the loop.
      remaining = remaining.slice(bounds.end);
    }

    return children;
  }

  render() {
    const { className, search, text } = this.props;

    return (
      <div className={className} title={text}>
        {search ? this.renderHighlights() : text}
      </div>
    );
  }
}
